/** @flow */
/**
 * Checks if argument is an instance of Array.
 */
export default function isArray(arg) {
  return Array.isArray(arg); // Object.prototype.toString.call(arg) === '[object Array]';
}
